<div class="flex flex-col">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-title color-blue">
      {{ this.data.Titule }}
    </p>

    <div class="flex justify-between items-center gap-4">
      <button
        (click)="downloadFileFromBlob()"
        class="flex! justify-center! items-center!"
        color="primary"
        mat-icon-button
      >
        <mat-icon>download</mat-icon>
      </button>
      <button
        (click)="closeModal()"
        class="flex! justify-center! items-center!"
        color="primary"
        mat-icon-button
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="flex-1 w-full min-w-75 md:min-w-125 lg:min-w-175">
    <div class="p-2 sm:p-4 lg:p-6">
      @if (pdfSrc) {
        <pdf-viewer
          [src]="pdfSrc"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="true"
          style="display: block; width: 100%; height: 80vh"
        ></pdf-viewer>
      }

      @if (imagePreview) {
        <div>
          <img
            class="max-h-100 sm:max-h-125 md:max-h-150 lg:max-h-162.5 w-full object-contain"
            [src]="imagePreview"
            alt="Image Preview"
            width="100%"
          />
        </div>
      }

      @if (isDoc) {
        <div class="p-8 flex justify-center items-center">
          <mat-icon class="text-8xl h-25! w-25! m-auto">description</mat-icon>
        </div>
      }
    </div>
  </div>
</div>
